import { type TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type MunichCityPassResolvedPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      mainPath: string;
      bookingsPath: string;
    };

export function resolveMunichCityPassApiPaths(
  transportContext: TransportAirlineApiContext
): MunichCityPassResolvedPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }

  if (transportContext.mode === "airline") {
    const iataCode = encodeURIComponent(transportContext.iataCode);
    const base = `v1/airports/${iataCode}/transports/munich-city-pass`;

    return {
      kind: "ok",
      mainPath: base,
      bookingsPath: `v1/airports/${iataCode}/bookings`
    };
  }

  return {
    kind: "ok",
    mainPath: "transport/munich-city-pass",
    bookingsPath: "transport/munich-city-pass/bookings"
  };
}
